import React, { useEffect, useMemo, useRef, useState } from "react";
import "../Style/Businesshl.css";
import { useLanguage } from "../Context/Languagecontext";

import cardImg1 from "../Assets/kkb.webp";
import cardImg2 from "../Assets/kkb.webp";
import cardImg3 from "../Assets/kkb.webp";

const images = [cardImg1, cardImg2, cardImg3];

function getPosition(index, activeIndex, total) {
  const diff = index - activeIndex;
  if (diff === 0) return "active";
  if ((activeIndex - 1 + total) % total === index) return "prev";
  if ((activeIndex + 1) % total === index) return "next";
  return "hidden";
}

export default function BusinessHighlight() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);
  const touchStartX = useRef(0);

  const { t } = useLanguage();

  const bh = t.businessHighlight;
  const cards = bh.cards;

  const activeCard = cards[activeIndex];

  const positionedCards = useMemo(
    () =>
      cards.map((card, index) => ({
        ...card,
        image: images[index],
        position: getPosition(index, activeIndex, cards.length),
      })),
    [activeIndex, cards]
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  const goNext = () => setActiveIndex((p) => (p + 1) % cards.length);
  const goPrev = () => setActiveIndex((p) => (p - 1 + cards.length) % cards.length);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(delta) < 40) return;
    delta < 0 ? goNext() : goPrev();
  };

  return (
    <section
  ref={sectionRef}
  className={`business-highlight ${
    visible ? "business-highlight--visible" : ""
  } ${t.lang === "ta" ? "business-highlight--ta" : ""}`}
  id="business-highlight"
>
      <div className="business-highlight__container">

        <div className="business-highlight__content">
          <span className="business-highlight__eyebrow">
            {bh.eyebrow}
          </span>

          <h2 className="business-highlight__title">
            {bh.title}
          </h2>

          <div key={activeCard.id} className="business-highlight__copy">
            <p className="business-highlight__label">{activeCard.label}</p>
            <h3 className="business-highlight__headline">{activeCard.title}</h3>
            <p className="business-highlight__description">{activeCard.description}</p>

            <div className="business-highlight__stat">
              <strong>{activeCard.metric}</strong>
              <span>{activeCard.metricLabel}</span>
            </div>
          </div>
        </div>

        <div
          className="business-highlight__carousel-wrap"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <div className="business-highlight__carousel">

            {positionedCards.map((card) => (
              <article
                key={card.id}
                className={`business-highlight__card business-highlight__card--${card.position}`}
                aria-hidden={card.position !== "active"}
              >
                <div className="business-highlight__card-badge">{card.id}</div>

                <div className="business-highlight__card-avatar">
                  <img src={card.image} alt={card.label} />
                </div>

                <div className="business-highlight__card-body">
                  <h4>{card.label}</h4>
                  <p>{card.cardText}</p>
                </div>

                <div className="business-highlight__card-footer">
                  <strong>{card.metric}</strong>
                  <span>{card.metricLabel}</span>
                </div>
              </article>
            ))}

          </div>

          <div className="business-highlight__controls">
            <button onClick={goPrev} className="business-highlight__arrow">←</button>

            <div className="business-highlight__dots">
              {cards.map((_, i) => (
                <button
                  key={i}
                  className={`business-highlight__dot ${
                    i === activeIndex ? "business-highlight__dot--active" : ""
                  }`}
                  onClick={() => setActiveIndex(i)}
                />
              ))}
            </div>

            <button onClick={goNext} className="business-highlight__arrow">→</button>
          </div>

        </div>
      </div>
    </section>
  );
}